/* eslint-disable jsx-a11y/media-has-caption */
import DOMPurify from 'dompurify';
import React, { useRef, useEffect } from 'react';

import FUNCTIONS from './functions';

export interface PlayerProps extends React.AllHTMLAttributes<HTMLVideoElement> {
  playing?: boolean;
  muted?: boolean;
  isYoutube?: boolean;
  showYoutube?: boolean; // fix next slide video remain play
}

const NativePlayer:React.FC<PlayerProps> = ({
  playing,
  src,
  muted,
  isYoutube,
  showYoutube,
  ...props
}) => {
  const ref = useRef < HTMLVideoElement | null >(null);

  useEffect(() => {
    if (!ref.current) return;
    if (playing) {
      ref.current.play();
    }
    if (!playing) {
      ref.current.pause();
    }
  }, [playing]);

  useEffect(() => {
    if (!ref.current) return;
    if (muted) {
      ref.current.muted = true;
    }
    if (!muted) {
      ref.current.muted = false;
    }
  }, [muted]);

  if (!src) return <div />;

  if (isYoutube) {
    return (
      <div
        className="o-nativePlayer"
      >
        {showYoutube && (
        <div
         // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={
            { __html: DOMPurify.sanitize(FUNCTIONS.youtubeControlIframe(src)) }
          }
        />
        )}
      </div>
    );
  }

  return (
    <div className="o-nativePlayer">
      <video
        {...props}
        ref={ref}
        playsInline
        autoPlay={muted}
      >
        <source src={src} type="video/mp4" />
      </video>
    </div>
  );
};

export default NativePlayer;
